import { AssessedTakeIcon } from '@public/icons';

import styles from './assessedTake.module.scss';

export interface AssessedTakeProps {
	value?: string;
	tooltipPosition?: 'bottom' | 'left';
}

export const AssessedTake = ({ value, tooltipPosition = 'bottom' }: AssessedTakeProps) => {
	return (
		<>
			{Number(value).toFixed(3).concat(' ML')}{' '}
			<div className={styles['tooltip']}>
				<AssessedTakeIcon customStyles={styles.icon} />
				<div
					className={[
						styles.tooltiptext,
						tooltipPosition == 'left' ? styles.tooltiptextLeft : {},
					].join(' ')}
				>
					Assessed take
				</div>
			</div>
		</>
	);
};
